import { useContext } from 'react'

import { PriceContext } from './PriceContext'

export const usePriceContext = () => useContext(PriceContext)
